import { onINP } from 'web-vitals/attribution';

function logSlowINPWhenTrackJSAvailable(metric) {
    const { value, attribution } = metric;

    if (value <= 200) return; // Ignore good responsiveness

    if (window.TrackJS) {
        window.TrackJS.console.log({
            metricValue: value,
            interactionTarget: attribution.interactionTarget,
            interactionType: attribution.interactionType,
            inputDelay: attribution.inputDelay,
            processingDuration: attribution.processingDuration,
            presentationDelay: attribution.presentationDelay,
            loadState: attribution.loadState,
        });
        window.TrackJS.track(new Error(`Slow INP detected`));
    }
}

if (window.requestIdleCallback) {
    requestIdleCallback(() => {
        onINP(logSlowINPWhenTrackJSAvailable, { reportAllChanges: true });
    });
} else {
    setTimeout(() => {
        onINP(logSlowINPWhenTrackJSAvailable, { reportAllChanges: true });
    }, 0);
}
